export const BotMembershipDuration = {
    Monthly: { label: '1 month', value: '2592000', shortLabel: '1m' },
    Yearly: { label: '1 year', value: '31536000', shortLabel: '1y' },
} as const

export const botMembershipDurationOptions = Object.keys(
    BotMembershipDuration,
) as (keyof typeof BotMembershipDuration)[]

export const getBotMembershipDuration = (key: keyof typeof BotMembershipDuration) => {
    const duration = BotMembershipDuration[key]
    if (!duration) {
        throw new Error(`Invalid membership duration: ${key}`)
    }
    return duration
}

export const getDurationKeyFromSeconds = (seconds: number): keyof typeof BotMembershipDuration => {
    const secondsStr = String(seconds)
    for (const [key, value] of Object.entries(BotMembershipDuration)) {
        if (value.value === secondsStr) {
            return key as keyof typeof BotMembershipDuration
        }
    }
    return 'Yearly'
}
